import { getGlobalHeadersAsObject } from "../global-headers";

export interface GradeConnectQueueItem {
	id: number;
	created: string;
	mode: number;
	mode_label: string;
	band: number | null;
	band_label: string | null;
	priority: number;
	assignment: number;
	user: number | null;
	person: number;
	viewed: string | null;
	dequeued: string | null;
	queue_data: Record<string, unknown> | null;
}

export interface GradeConnectQueueResponse {
	results: GradeConnectQueueItem[];
}

export async function getPersonGradeConnectQueue(
	personId: number
): Promise<GradeConnectQueueResponse> {
	const response = await fetch(`/api/v2/persons/${personId}/grade_connect_queue/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch GradeConnectQueue: ${response.status}`);
	}

	return response.json();
}
